// src/redux/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userDetails: null, // This will hold user data
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload; // Save user data to the state
    },
    setLoading: (state, action) => {
      state.loading = action.payload; // For loading state (optional)
    },
    setError: (state, action) => {
      state.error = action.payload; // For error handling (optional)
    },  
  },
});

// Export actions to be dispatched
export const { setUserDetails, setLoading, setError } = userSlice.actions;

// Export the reducer
export default userSlice.reducer;
